import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d4d699bc")

_pushScopeId("data-v-d4d699bc")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Insufficient Credit")
const _hoisted_2 = { class: "flex-1 insufficient_text pr-20" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Insufficient credit")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, {
    title: _withId(() => [
      _createVNode(_component_Pic, {
        src: "membership/tips",
        width: "20",
        height: "20",
        class: "mr-8"
      }),
      _createVNode(_component_t, { path: "credit_13" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    controls: _withId(() => [
      _createVNode("button", {
        class: "flex-1 btn line",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_t, {
          path: "credit_15",
          custom: ""
        }, {
          default: _withId(({td}) => [
            _createTextVNode(_toDisplayString(td || 'Close'), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode("button", {
        class: "flex-1 btn primary mr-30",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_t, {
          path: "credit_16",
          custom: ""
        }, {
          default: _withId(({td}) => [
            _createTextVNode(_toDisplayString(td || 'Got it'), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_t, { path: "credit_14" }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
})